var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"poll-title"},[_vm._v(_vm._s(_vm.poll.title)+" "),_vm._t("timer")],2),_c('rating-slider',{staticClass:"poll-slider",attrs:{"max":_vm.poll.variants.length,"marks":_vm.marks},on:{"change":_vm.setVariant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }